import { Container, Row, Col, Spinner } from "react-bootstrap";
import { T } from "../../../helpers/Language";
import MainLayout from "../../../layouts/MainLayout";
import { useState, useEffect } from "react";
import {getGenReportsInfo, getHashReport, getReportHashed } from '../../../api/actions/Reports';
import './Exports.scss';

const Exports = () => {
    const [reports, setReports] = useState("0");
    const [period, setPeriod] = useState("m");
    const [loadingStatus, setLoadingStatus] = useState("empty");
    const [cycle, setCycle] = useState('');
    const [data, setData] = useState({ReportCycles: [], FinalCycles: []});
    const [chapels, setChapels] = useState([]);
    const [selectChapel, setSelectChapel] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoading(true);
        const res = await getGenReportsInfo();

        setData(res);
        setLoading(false);
        setCycle(res?.ReportCycles[0] || '');
        setChapels(res.MemberFinancialReportChapels);
    }

    const handleChangeReports = (name) => {
        setReports(name);
        setPeriod("m");
    }

    const changeCycle = ({ target }) => {
        const { value } = target;
        setCycle(value);
    }

    const handleChangePeriod = (name) => {
        setPeriod(name);
    }

    const utf8_to_b64 = (str) => { 
        return window.btoa(unescape(encodeURIComponent(str))); 
    }

    const submitReport = async () => {
        setLoadingStatus("loading");

        try {
            let usedPeriod = period === "m" ? 1 : 0;
            let pdf = await getHashReport(cycle, reports, selectChapel, usedPeriod);
            let pdfHash = await getReportHashed(pdf.file_hash);
            window.open(pdfHash);

            setLoadingStatus("empty");
        } catch (error) {
            setLoadingStatus("error");
        }

        return;
    }

    const changeChapel = ({ target }) => {
        const { value } = target
        setSelectChapel(value);
    }

    return (
        <MainLayout pageTitle={T('REPORTS_EXPORTS_TITLE')}>
            <Container fluid className="reports-exports">
                <Row className="genreportsApp">
                    <div className={`fiducialLoading ${loading ? 'active' : ''}`}>
                        <div className="progressbar"></div>
                    </div>
                    <Col md={12} className="contentBlock content generateReports">
                        <div className="reportsBlock">
                            <div className="title">
                                Desired Report
                            </div>
                            <div>
                                <input type="radio" checked={reports === "0"} onChange={() => handleChangeReports("0")} />
                                <span onClick={() => handleChangeReports("0")} className="desc">Profit & Loss</span>
                                {/* ProfitLossPL = ReportCycles | FinalCycles | 0 */}
                            </div>
                            <div>
                                <input type="radio" checked={reports === "3"} onChange={() => handleChangeReports("3")} />
                                <span onClick={() => handleChangeReports("3")} className="desc">Balance Sheet</span>
                                {/* BalanceSheetBS = ReportCycles | FinalCycles | 3 */}
                            </div>
                            <div>
                                <input type="radio" checked={reports === "4"} onChange={() => handleChangeReports("4")} />
                                <span onClick={() => handleChangeReports("4")} className="desc">Sales Activity</span>
                                {/* SalesActivitySA = SalesActivityReportCycles | 4 */}
                            </div>
                            <div>
                                <input type="radio" checked={reports === "5"} onChange={() => handleChangeReports("5")} />
                                <span onClick={() => handleChangeReports("5")} className="desc">Aging</span>
                                {/* AgingAG = ReportCycles | 5 */}
                            </div>
                            {/**<div>
                                <input type="radio" checked={reports === "12"} onChange={() => handleChangeReports("12")} />
                                <span onClick={() => handleChangeReports("12")} className="desc">Profit & Loss & Balance Sheet</span>
                            /**}
                                {/* ProfitLossPL&BalanceSheetBS, = ReportCycles | FinalCycles | 12 **/}
                            {/**</div>**/}
                        </div>
                        {/** removed 12 temp **/}
                        <div className={`reportsBlock ${["0", "3", "12"].includes(reports) ? "show" : "hide"}`}>
                            <div className="title">
                                Period
                            </div>
                            <div>
                                <input type="radio" checked={period === "m"} onChange={() => handleChangePeriod("m")} /><span onClick={() => handleChangePeriod("m")} className="desc">Monthly</span>
                            </div>
                            <div>
                                <input type="radio" checked={period === "f"} onChange={() => handleChangePeriod("f")} /><span onClick={() => handleChangePeriod("f")} className="desc">Final</span>
                            </div>
                        </div>
                        <div className="reportsBlock">
                            <div className="title">
                                From
                            </div>
                            {/** removed 12 temp **/}
                            {(["0", "3"].includes(reports)) && 
                                <div>
                                    <select onChange={changeCycle} value={cycle} name="" id={reports}>
                                        {
                                            period === "m" && data?.ReportCycles.map(ncycle => (
                                                <option key={ncycle} alue={ncycle}>{ncycle}</option>
                                            ))
                                        }
                                        {
                                            period === "f" && data?.FinalCycles &&
                                            data?.FinalCycles.map(ncycle => (
                                                <option value={ncycle}>{ncycle}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            }
                            {(["4", "5"].includes(reports)) && 
                                <div>
                                    <select onChange={changeCycle} value={cycle} name="" id={reports}>
                                        {
                                            data?.SalesActivityReportCycles?.map(ncycle => (
                                                <option key={ncycle} value={ncycle}>{ncycle}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            }
                            <div className="selectChapel">
                                <select onChange={changeChapel} value={selectChapel} name="" id="">
                                    <option value={""}>Combined</option>
                                    {
                                        chapels?.map(chapel => (
                                            <option key={chapel.CHAPEL} value={chapel.CHAPEL}>{`${chapel.NAME} - Chapel ${chapel.CHAPEL}`}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="submitBlock">

                                <div onClick={submitReport} className={`submitButton clickable ${loadingStatus === "error" ? "danger" : "primary"}`}>
                                    {loadingStatus === "empty" && "Generate Report"}
                                    {loadingStatus === "loading" &&
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />}
                                    {loadingStatus === "error" && "Sorry failed !"}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row >
            </Container>
        </MainLayout>
    )
}

export default Exports;
